import {SiteAccessibility} from "./data/client.gen";
import {Instant, Now, PlainDate, PlainDateTime, ZonedDateTime} from "@variocube/app-ui";

export type Weekday = keyof SiteAccessibility;
export const WEEKDAYS: Weekday[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export function getWeekday(daysInWeek: number) {
	return WEEKDAYS[daysInWeek - 1];
}

export function getWeekdayFromDate(datetime: ZonedDateTime) {
	return getWeekday(datetime.daysInWeek);
}

export function getStartOfDay(datetime: ZonedDateTime) {
	return datetime.with({
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0,
	});
}

export function parseTime(time: string | null | undefined) {
	if (time) {
		const parts = time.split(":");
		try {
			return {
				hour: Number.parseInt(parts[0]),
				minute: Number.parseInt(parts[1]) || 0,
				second: Number.parseInt(parts[2]) || 0,
			};
		}
		catch (error) {
			console.error("Could not parse time", time);
			return undefined;
		}
	}
}

export function isValidPeriod(from: ZonedDateTime|undefined, until: ZonedDateTime|undefined, minDate: ZonedDateTime|undefined, maxDate: ZonedDateTime|undefined) {
	if (from === undefined || until === undefined) {
		console.error("Either from or until date is not defined.");
		return false;
	}
	if (PlainDate.compare(from.toPlainDate(), until.toPlainDate()) > 0) {
		console.error("From date is after until date.");
		return false;
	}
	if (minDate !== undefined && PlainDate.compare(minDate.toPlainDate(), from.toPlainDate()) > 0) {
		console.error("From date is before min. date.");
		return false;
	}
	if (maxDate !== undefined && PlainDate.compare(maxDate.toPlainDate(), until.toPlainDate()) < 0) {
		console.error(`Until date is after max. date. maxDate (${maxDate.toJSON()}), until: (${until.toJSON()})`);
		return false;
	}
	return true;
}

export function parseZoneDateTimeFromInstant(instant: string, zoneId: string) {
	return Instant.from(instant).toZonedDateTimeISO(zoneId)
}

export function parseZoneDateTimeFromDateTime(datetime: string, zoneId: string) {
	return PlainDateTime.from(datetime).toZonedDateTime(zoneId)
}

export function parseZoneDateTimeFromDate(date: string, zoneId: string) {
	return PlainDate.from(date).toZonedDateTime(zoneId);
}

export function getZoneDateTimeNow(zoneId: string) {
	return Now.zonedDateTimeISO(zoneId)
}
